import { formValueSelector } from 'redux-form';

export const generateBundleValues = (bundleData, ancillaryBundleData = null) => {
  const { id, options } = { ...bundleData };

  const selection =
    ancillaryBundleData && options?.find((option) => option.id === ancillaryBundleData.value?.id);

  return (
    (selection &&
      ancillaryBundleData && [
        {
          id,
          title: selection.name,
          price: selection?.price?.price?.value,
          value: selection.id,
          products: selection.content.reduce((acc, product) => {
            if (product.name !== null && product.included) {
              acc.push(product.name);
            }
            return acc;
          }, []),
          ids: selection.content.reduce((acc, product) => {
            if (product.productTypeId !== null && product.included) {
              acc.push(Number(product.productTypeId));
            }
            return acc;
          }, []),
          options,
          selectedOption: ancillaryBundleData.value.id,
        },
      ]) ||
    []
  );
};

export const getAddedAncillaryBundles =
  (form, bundleData, isAncillaryBundlingEnabled) => (state) => {
    const reduxValue = formValueSelector(form)(state, 'bundles');
    const bundles = (reduxValue && [...reduxValue]) || [];

    if (isAncillaryBundlingEnabled) {
      const TDPageBundle = generateBundleValues(
        bundleData,
        formValueSelector(form)(state, 'ancillaryBundle'),
      );
      if (TDPageBundle.length > 0) {
        bundles.push(...TDPageBundle);
      }
    }

    if (!bundles || bundles.length === 0) {
      return {
        bundles: [],
        bundlesTotalPrice: 0,
      };
    }
    return {
      bundles: bundles.filter((bundle) => bundle.price > 0),
      bundlesTotalPrice: bundles.reduce((total, bundle) => total + bundle.price, 0),
    };
  };
